import Home from "./home/Home";
import GuestHome from "./guestHome/GuestHome";
import Login from "./login/Login";
import EsqueceuSenha from "./esqueceuSenha/EsqueceuSenha";
import Renter from "./renterUrgente/Renter";
const pages = {
  Home,
  Login,
  EsqueceuSenha,
  GuestHome,
  Renter,
};
export default pages;
